export type ThemeMode = 'system' | 'light' | 'dark';

export function storedThemeMode(): ThemeMode {
  const value = localStorage.getItem('antix_theme');
  return value === 'light' || value === 'dark' || value === 'system' ? value : 'system';
}

export function nextThemeMode(mode: ThemeMode): ThemeMode {
  if (mode === 'system') return 'light';
  if (mode === 'light') return 'dark';
  return 'system';
}

export function applyThemeMode(mode: ThemeMode) {
  localStorage.setItem('antix_theme', mode);
  const prefersDark = window.matchMedia('(prefers-color-scheme: dark)').matches;
  const useLight = mode === 'light' || (mode === 'system' && !prefersDark);
  if (useLight) document.documentElement.dataset.theme = 'light';
  else delete document.documentElement.dataset.theme;
}
